import { request } from "@/interface/helper";

const str = "gamenews";

export const gamenews = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/game/news/list" }),
    add: (data) => request({ data, method: "post", url: "/game/news/add" }),
    detail: (data) => request({ data, method: "post", url: "/game/news/detail" }),
    edit: (data) => request({ data, method: "post", url: "/game/news/modify" }),
    getLangs: (data) => request({ data, method: "get", url: "/game/news/transfer" }),
    newsDetail: (data) => request({ data, method: "post", url: "/game/news/getlangdetail" }),
    setOriginal: (data) => request({ data, method: "post", url: "/game/news/setoriginallanguage" }),
    setLangDetail: (data) => request({ data, method: "post", url: "/game/news/setlangdetail" }),
    setPublish: (data) => request({ data, method: "post", url: "/game/news/publishlang" }),
  },
};
